import React from 'react';
import { createUseStyles } from 'react-jss';
import moment from 'moment';
import { Theme } from '@app/theme';
import { Participation, useMe, useParticipant } from '@app/api';

import {
  CardHomeBase,
  StyleCardHome,
} from '../../Home/components/CardHomeBase';
import { useTranslation } from 'react-i18next';
import { IconsMeetingList } from '../../Home/components/IconsMeetingList';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.label,
    marginBottom: theme.marginBase,
  },
  date: {
    ...theme.fonts.caption,
    marginBottom: theme.marginBase,
    display: 'block',
  },
  icons: {
    display: 'flex',
    gap: theme.marginBase,
    flexWrap: 'wrap',
  },
}));

interface Props {
  participation: Participation;
  className?: string;
  variant?: 'plain' | 'transparent';
}

export const PastParticipationCard = ({ className, participation }: Props) => {
  const classes = useStyles();
  const { data: me } = useMe();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { data: participant } = useParticipant(participation.participantId);
  const { session } = participation;

  const date = participation.appointment?.date;
  const timezone = participant?.timezone || me?.timezone || moment.tz.guess();

  if (!participant || !session) {
    return null;
  }

  return (
    <CardHomeBase
      style={StyleCardHome.WHITE}
      title={t('studies.cards.past.title', { context: participation.status })}
      className={className}
    >
      <div className={classes.title}>{session.title}</div>

      {!!date && (
        <time className={classes.date} dateTime={date}>
          {Intl.DateTimeFormat(language, {
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit',
            timeZone: timezone,
          }).format(moment(date).toDate())}
        </time>
      )}

      <IconsMeetingList
        session={participation.session}
        focus={false}
        participation={participation}
      />
    </CardHomeBase>
  );
};
